/** @deprecated moved to libs folder */
export function isSafari(windowRef: Window): boolean {
    return windowRef.navigator.vendor && windowRef.navigator.vendor.indexOf('Apple') > -1 &&
        windowRef.navigator.userAgent &&
        windowRef.navigator.userAgent.indexOf('CriOS') == -1 &&
        windowRef.navigator.userAgent.indexOf('FxiOS') == -1;
}
